export const SEND_CONTENT_SUCCESS = "SEND_CONTENT_SUCCESS";
export const SEND_CONTENT_FAIL = "SEND_CONTENT_FAIL";
export const RECEIVE_CONTENT_SUCCESS = "RECEIVE_CONTENT_SUCCESS";
export const RECEIVE_CONTENT_FAIL = "RECEIVE_CONTENT_FAIL";
export const GET_MY_PARTICIPANTS = "GET_MY_PARTICIPANTS";
export const GET_SINGLE_CHAT = "GET_SINGLE_CHAT";
